import { formCategories } from "./../../helpers/index.js";

export const templateEditCases = {
  EDIT_SECTION_HEADING: "EDIT_SECTION_HEADING",
  DELETE_SECTION: "DELETE_SECTION",
  CONFIGURE_SECTION: "CONFIGURE_SECTION",
  CHANGE_SECTION_SEQUENCE: "CHANGE_SECTION_SEQUENCE",
  EDIT_QUESTION: "EDIT_QUESTION",
  ADD_QUESTION: "ADD_QUESTION",
  DELETE_QUESTION: "DELETE_QUESTION",
  CONFIGURE_QUESTION: "CONFIGURE_QUESTION",
  CHANGE_QUESTION_SEQUENCE: "CHANGE_QUESTION_SEQUENCE",
} as const;
export const preDefinedFormCategories = [
  formCategories.bills,
  formCategories.inspection,
  formCategories.progressUpdates,
  formCategories.changeOrder,
  formCategories.issues,
  formCategories.mailBox,
  formCategories.projects,
  formCategories.model,
  formCategories.reviews,
  formCategories.contract,
  formCategories.files,
];

export const formCategoryFieldValueMapper: Record<string, { quantity: string; amount: string; percent: string }> = {
  [formCategories.inspection]: {
    quantity: "inspectedQuantity",
    amount: "inspectedAmount",
    percent: "inspectedPercentageOfTotal",
  },
  [formCategories.progressUpdates]: {
    quantity: "usedQuantity",
    amount: "usedAmount",
    percent: "usedPercentageOfTotal",
  },
  [formCategories.bills]: {
    quantity: "billedQuantity",
    amount: "billedAmount",
    percent: "billedPercentageOfTotal",
  },
};

export const formStatuses = {
  inProgress: "IN_PROGRESS",
  rejected: "REJECTED",
  approved: "APPROVED",
  submitted: "SUBMITTED",
} as const;

export const formCounterMapper: Record<string, string> = {
  [formCategories.inspection]: "inspectionsCounter",
  [formCategories.progressUpdates]: "progressUpdatesCounter",
  [formCategories.bills]: "billsCounter",
  [formCategories.changeOrder]: "changeOrdersCounter",
  [formCategories.payments]: "paymentsCounter",
};

export default {
  templateEditCases,
  formStatuses,
  formCategoryFieldValueMapper,
  formCounterMapper,
  preDefinedFormCategories,
};
export const initialFormValue: any = [
  {
    heading: "Pre-Submission",
    dataSource: [],
    submitBtnTxt: "Submit",
    allowedUsersToSubmit: [],
    rejectBtnTxt: "Reject",
    allowedUsersToReject: [],
    actionStatus: false,
    actionDetails: {},
  },
  {
    heading: "Post-submission",
    dataSource: [],
    rejectBtnTxt: "Reject",
    approveBtnTxt: "Approve",
    allowedUsersToApprove: [],
    allowDynamicUserConfig: false,
    allowedUsersToReject: [],
    actionStatus: false,
    actionDetails: {},
  },
];
